import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api-client";
import { qk } from "@/lib/query-keys";
import { toSearchParams, type TimeRange } from "@/lib/time-range";
import { AuthMetricsSchema, type AuthMetrics } from "@/lib/validation";
import type { UseMetricOptions } from "./useTraffic";

export function useAuthMetrics(
  range: TimeRange,
  options: UseMetricOptions = {},
) {
  return useQuery<AuthMetrics>({
    queryKey: qk.metrics.auth(range),
    queryFn: async ({ signal }) => {
      const raw = await api.get<unknown>(
        `/api/v1/metrics/auth?${toSearchParams(range).toString()}`,
        { signal },
      );
      return AuthMetricsSchema.parse(raw);
    },
    enabled: options.enabled !== false,
    staleTime: 60_000,
  });
}
